import { ReportValues } from "common/api/org.service";
import { checkDate } from "common/helpers/Date";
import { DateStringNumber } from "common/records";
import { jobResultingConfigToJSON } from "common/records/JobResultingConfig";
import {
  IPreferenceConfigData,
  IPreferenceConfigRecord,
  preferenceConfigFromJSON,
} from "common/records/PreferenceConfig";
import { List, Map, Record, fromJS } from "immutable";

export const preferencesFromJSON = (json: Partial<IPreferenceData>) => {
  const record = { ...(json as any) };

  record.acl = fromJS(json.acl);

  record.config = preferenceConfigFromJSON(json.config || {});

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new PreferenceRecord(record);
};

export const toJSON = (preference: PreferenceRecord) => {
  const json = preference.toJS() as Partial<IPreferenceData>;

  if (json.id === 0) {
    delete json.id;
  }

  if (json.org_id === 0) {
    delete json.org_id;
  }

  if (preference.config.job_resulting && json.config) {
    json.config.job_resulting = jobResultingConfigToJSON(preference.config.job_resulting);
  }

  return json as IPreferenceData;
};

export type PreferenceAclKeys = "reports" | "reports_columns" | "estimator" | "tools";
export type PreferenceAclValues =
  | "eagleview"
  | "enforce_required_magic_wand"
  | "enforce_required_signable_doc"
  | "full"
  | "multiple_groups"
  | ReportValues;

export interface IPreferenceData {
  id: number;
  org_id: number;
  acl: { [key in PreferenceAclKeys]?: PreferenceAclValues[] };
  config: IPreferenceConfigData;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IPreferenceRecord {
  id: number;
  org_id: number;
  acl: Map<PreferenceAclKeys, List<string>>;
  config: IPreferenceConfigRecord;
  created_at: string;
  updated_at: string;
}

const defaultPreferenceProps = {
  id: 0,
  org_id: 0,
  acl: Map<PreferenceAclKeys, List<string>>(),
  config: preferenceConfigFromJSON({}),
  created_at: "",
  updated_at: "",
};

export class PreferenceRecord extends Record(defaultPreferenceProps) implements IPreferenceRecord {}
